import { render, staticRenderFns } from "./SCrud.vue?vue&type=template&id=6636c164&"
import script from "./SCrud.vue?vue&type=script&lang=js&"
export * from "./SCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports